export default "__VITE_ASSET__Bzf36qQ0__"